// extracted by mini-css-extract-plugin
module.exports = {"background":"popover_background__217Kq","content":"popover_content__iScld"};